export const SUGGESTION_TYPE = {
  PRODUCT: 0,
  CATEGORY: 1,
} as const

export const SUGGESTION_LABEL = {
  [SUGGESTION_TYPE.PRODUCT]: 'Produto',
  [SUGGESTION_TYPE.CATEGORY]: 'Categoria',
} as const